import {Loader, SimpleGrid, Stack} from '@mantine/core'
import {useQuery} from '@tanstack/react-query'
import {createFileRoute} from '@tanstack/react-router'

import {getGapAnalysis} from 'src/api/client/api'
import DonorPyramid from 'src/components/analytics/donor-pyramid'
import {
    GiftCommitmentsExportContent,
    GiftCommitmentsHeader,
    GiftCommitmentsTable,
} from 'src/components/analytics/gift-commitments'
import {ExportImageButton} from 'src/components/export-image-button'
import {PageHeader} from 'src/components/page-header'
import {useScenarioPlanning} from 'src/components/scenario/scenario-context'
import {SectionCard} from 'src/components/section-card'

export const Route = createFileRoute('/_authed/organizations/$orgId/gap-analysis')({
    component: GapAnalysisPage,
})

function GapAnalysisPage() {
    const {orgId} = Route.useParams()
    const {appliedScenario} = useScenarioPlanning()

    const {data, isLoading, error} = useQuery({
        queryKey: ['page', orgId, 'gap-analysis', appliedScenario],
        queryFn: () => getGapAnalysis(orgId, appliedScenario),
    })

    if (isLoading) {
        return <Loader size="lg" style={{display: 'block', margin: '60px auto'}} />
    }

    if (error) {
        return <div>Error loading page: {(error as Error).message}</div>
    }

    if (!data) return null

    const headerTitle = 'Gap Analysis'
    const headerDescription = 'Required prospects vs identified qualified prospects by gift level.'

    return (
        <Stack>
            <PageHeader
                title={headerTitle}
                description={headerDescription}
                actions={
                    <ExportImageButton
                        title={headerTitle}
                        renderContent={() => <GiftCommitmentsExportContent data={data} />}
                        filenameBase="gap-analysis"
                        kinds={['table']}
                        exportWidthPx={{table: 620}}
                    />
                }
            />
            <SectionCard title={<GiftCommitmentsHeader data={data} />}>
                <SimpleGrid cols={{base: 1, lg: 2}} spacing={{base: 'lg', lg: 'xl'}}>
                    <Stack gap="sm" align="center">
                        <DonorPyramid rows={data.rows} />
                    </Stack>
                    <GiftCommitmentsTable data={data} maw="100%" />
                </SimpleGrid>
            </SectionCard>
        </Stack>
    )
}
